





































import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  IInterestAction,
  IInterestProcessInvoice,
  existingCharge,
} from '@/app/interest-charge-process';
import InterestChargeForm from './InterestCharges/InterestChargeForm.vue';

@Component({
  components: {
    InterestChargeForm,
  },
})
export default class InterestChargeNextStep extends Vue {
  @Prop({ required: true }) private invoice!: IInterestProcessInvoice;
  @Prop({ required: true }) private action!: IInterestAction;

  private get charge() {
    return existingCharge(this.invoice);
  }

  private get actionLabel(): string {
    return this.$t(
      `Invoice.InterestCharge.Process.Action.${this.action.type}`,
      { date: this.action.availableFrom, amount: this.action.totalAmount },
    ) as string;
  }

  private get waitTitle(): string {
    return this.$t(
      'Invoice.InterestCharge.Process.Action.waitTooltip',
      { date: this.action.availableFrom },
    ) as string;
  }
}
